const hasExample = (message: string) => /\b(example|e\.g\.)\b/i.test(message);

export const formatValidationError = (
  error?: string,
  example = 'a valid value in the required format',
) => {
  if (!error) return '';

  const message = error[0].toUpperCase() + error.substring(1);
  return hasExample(message) ? message : `${message} Example: ${example}`;
};

export const getTextInputExample = ({
  name,
  placeholder,
  type,
}: {
  name: string;
  placeholder?: string;
  type?: string;
}) => {
  if (placeholder) return placeholder;
  if (type === 'email' || name.includes('email')) return 'name@example.com';
  if (type === 'tel' || name.includes('phone')) return '+61 400 000 000';
  if (name.includes('date')) return '31/12/1990';
  if (name.includes('first_name')) return 'Jane';
  if (name.includes('last_name')) return 'Smith';
  if (name.includes('street_number')) return '123';
  if (name.includes('unit_number')) return '12A';
  if (name.includes('street_name')) return 'George';
  if (name.includes('locality') || name.includes('suburb')) return 'Sydney';
  if (name.includes('state') || name.includes('province')) return 'New South Wales';
  if (name.includes('postcode')) return '2000';
  if (name === 'acn') return '123456789';
  if (name === 'abn') return '12345678901';
  if (name === 'nzbn') return '9429041234567';
  if (name.includes('social_security')) return '123-45-6789';
  if (name.includes('bsb')) return '123-456';
  if (name.includes('account')) return '12345678';
  if (name.includes('tin') || name.includes('tfn')) return '123456789';
  if (name.includes('passport')) return 'A12345678';
  if (name.includes('address')) return '123 George Street';
  if (name.includes('name')) return 'Jane Smith';
  if (name.includes('number') || name.includes('amount')) return '123';

  return 'a valid value in the required format';
};
